import request from "@/CommonDP/utils/request";
export default {
    qualityAdd(params){
      return request.post(`/qualityAssurance/add`,params);
    },
    qualityGet(params) {
      return request.post(`/qualityAssurance/get`,params);
    },
    qualityDic(prjId) {
      return request.get(`/qualityAssurance/getDic?prjId=${prjId}`);
    },
    // 发起流程业务
    addFlowBusiness(dto) {
      return request.post("/qualityAssurance/addFlowBusiness", dto);
    },
     // 查询业务表单
    getBusinessForm(flowInstanceId) {
      return request.get(`/qualityAssurance/business/get?flowInstanceId=${flowInstanceId}`);
    },
    getZeRenren(prjId,roleItemId) {
      return request.get(`/qualityAssurance/getZeRenren?prjId=${prjId}&roleItemId=${roleItemId}`);
    },
    // 流程再发起
    flowAgain(dto) {
      return request.post("/qualityAssurance/cqdzReStart", dto);
    },
    //获取选择集
    getSelectSetFolderTree(params) {
      return request.post(`/qualityAssurance/getSelectSetFolderTree`,params);
    },
    // 添加选择集
    addSelectSetFolderTree(params) {
      return request.post("/qualityAssurance/addSelectSetFolderTree", params);
    },
    updateSelectSetFolderTree(params) {
      return request.post("/qualityAssurance/updateSelectSetFolderTree", params);
    },
    delSelectSetFolderTree(params) {
      return request.post(`/qualityAssurance/delSelectSetFolderTree`,params);
    },
    delModelQua(qualityId) {
      return request.get(`/qualityAssurance/del?qualityId=${qualityId}`);
    },
    getFormDataByBusinessID(businessID) {
      return request.get(`/qualityAssurance/getFormDataByBusinessID?businessID=${businessID}`);
    },
}